import Box from '@mui/material/Box';

import { Invoice } from '~hooks/useInvoices/models';

import { columns, gridTemplateColumns } from './invoices-table-columns';
import TableHeader from './TableHeader';
import TableRow from './TableRow';

interface InvoicesTableProps {
  invoices: Invoice[];
}

export default function InvoicesTable({ invoices }: InvoicesTableProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridAutoRows: 'auto',
        gridTemplateColumns,
        gridTemplateRows: '35px',
      }}
    >
      {columns.map((column) => (
        <TableHeader key={column.key} title={column.title} sx={column.sx} />
      ))}

      {invoices.map((invoice) => (
        <TableRow key={invoice.id} invoice={invoice} />
      ))}
    </Box>
  );
}
